'use strict';

import { scrollUpdateAnim } from './Scrolls.js';
import { runAutoDecrypt, chatDecrypt } from './crypter.js';
import { minimizableInit } from './minimizable.js';

// Šis ir gan čatiem gan miracle;

export async function miracleSync(list, currentId, skipId, ismiracle) {
    try {
        if (list) {
            var scrollUpdate = 0;
            var promises = [];
            $.each(list, function (idx, item) {
                // skipId var būt array vai single value;
                if (skipId) {
                    if (Array.isArray(skipId)) {
                        if (skipId.includes(item.id)) {
                            return;
                        }
                    } else if (skipId == item.id) {
                        return;
                    }
                }

                if (item.deleted) {
                    scrollUpdate += removeMiracleItem(item.id, currentId, ismiracle);
                } else {
                    promises.push(updateMiracleItem(item.id, item, currentId, ismiracle).then((value) => {
                        scrollUpdate += value;
                    }));
                }
            });

            if (promises.length) {
                await Promise.all(promises).then((values) => {
                    //console.log('Promise.all DONE');
                });
            }

            if (scrollUpdate) {
                scrollUpdateAnim(scrollUpdate, 200);
            }

            resetChatItemExists();
        }
    } catch (e) {
        console.log('E', e);
    }
}

export function removeMiracleItem(id, currentId, ismiracle, oncomplete) {
    var scrollUpdate = 0;
    $('.chatItem[data-id="' + id + '"]').each(function () {
        const self = this;

        if (currentId) {
            if (ismiracle) {
                if (currentId < id) {
                    scrollUpdate = 0 - $(self).outerHeight();
                }
            } else {
                if (currentId > id) {
                    scrollUpdate = 0 - $(self).outerHeight();
                }
            }
        }

        $(self).addClass('removing').stop(true, false).animate({ height: 0 }, {
            duration: 200,
            easing: 'linear',
            complete: function () {
                $(self).remove();
            }
        });
    });

    return scrollUpdate;
}

export async function updateMiracleItem(id, item, currentId, ismiracle) {
    var scrollUpdate = 0;
    if (!$('.chatItem[data-id="' + id + '"]').length) {
        var found = null, after = false;
        if (!$('.chatItem').length) {
            found = $('.cht2fld-options-tpl').first().get(0);
        } else {
            var prev, curid, foundsmall = false;

            if (ismiracle) {
                // ismiracle jāpievieno ir pirms pirmo id kas ir mazāks par doto id jo kārtojas DESC
                $('.chatItem').each(function () {
                    prev = this;
                    curid = $(this).data('id');
                    if (curid < id) {
                        foundsmall = true;
                        return false; // breaks
                    }
                });
            } else {
                after = true;
                // čata ieraksts jāpievienot ir aiz pirmo id kas ir
                $('.chatItem').each(function () {
                    curid = $(this).data('id');
                    if (curid > id) {
                        foundsmall = true;
                        return false; // breaks
                    }
                    prev = this;
                });
            }

            if (foundsmall) {
                found = prev;
            } else if (prev) {
                found = prev;
                after = ismiracle ? true : true;
            }
        }

        if (found) {
            var $newItem = $(item.html).each(function () {
                const self = this;
                $(self).css({
                    position: 'relative',
                    height: 0
                }).append(
                    $('<div class="chatItem chatItemUpdating"></div>').each(function () {
                        if (ismiracle) {
                            $(this).append($(self).find('.added').clone());
                        } else {
                            $(this).append($(self).find('.author').clone());
                        }
                        $(this).append($(self).find('.text').clone());
                    })
                );
            });

            await runAutoDecrypt($newItem);

            if (after) {
                $(found).after($newItem);
            } else {
                $(found).before($newItem);
            }

            $newItem.each(function () {
                const self = this;
                var update = function () {
                    $(self).find('.chatItemUpdating').remove();
                    $(self).css({ height: '', position: '' });
                    if ($(self).find('.minimizable').length) {
                        if (typeof minimizableInit === 'function') {
                            minimizableInit(self);
                        }
                    }
                };

                var newHeight = $(self).find('.chatItemUpdating').outerHeight();
                $(self).stop(true, false).animate({ height: newHeight }, {
                    duration: 200,
                    easing: 'linear',
                    complete: function () {
                        update();
                    }
                });

                if (currentId) {
                    if (ismiracle) {
                        if (currentId < id) {
                            scrollUpdate = newHeight - $(self).outerHeight();
                        }
                    } else {
                        if (currentId > id) {
                            scrollUpdate = newHeight - $(self).outerHeight();
                        }
                    }
                }

            });
        }

        return scrollUpdate;
    }

    if (item.cct) {
        item.cct = await chatDecrypt(item.cct);
    }
    item.text = await chatDecrypt(item.text);

    $('.chatItem[data-id="' + id + '"]').each(function () {
        const self = this;

        $(self).css({
            position: 'relative'
        }).append(
            $('<div class="chatItem chatItemUpdating"></div>').each(function () {
                if (ismiracle) {
                    $(this).append($(self).find('.added').clone());
                } else {
                    $(this).append(
                        $(self).find('.author').clone().each(function () {
                            if (item.cct) {
                                if ($(this).find('.chatEd').length) {
                                    $(this).find('.chatEd').html(item.cct);
                                } else {
                                    $(this).html(item.cct);
                                }
                            }
                        })
                    );
                }
                $(this).append(
                    $(self).find('.text').clone().each(function () {
                        if ($(this).find('.chatEd').length) {
                            $(this).find('.chatEd').html(item.text);
                        } else {
                            $(this).html(item.text);
                        }
                    })
                );
            })
        );

        var update = function () {
            $(self).find('.chatItemUpdating').remove();
            $(self).find('.text').each(function () {
                if ($(this).find('.chatEd').length) {
                    $(this).find('.chatEd').html(item.text);
                } else {
                    $(this).html(item.text);
                }
            });
            if (!ismiracle) {
                $(self).removeClass('cc' + (item.who == 2 ? 1 : 2)).addClass('cc' + item.who);
                $(self).find('.author').each(function () {
                    if (item.cct) {
                        if ($(this).find('.chatEd').length) {
                            $(this).find('.chatEd').html(item.cct);
                        } else {
                            $(this).html(item.cct);
                        }
                    }
                });
            }
            $(self).css({ height: '', position: '' });

            if ($(self).find('.minimizable').length) {
                if (typeof minimizableInit === 'function') {
                    minimizableInit(self);
                }
            }
        };

        var newHeight = $(self).find('.chatItemUpdating').outerHeight();
        if ($(self).outerHeight() != newHeight) {
            if (currentId) {
                if (ismiracle) {
                    if (currentId < id) {
                        scrollUpdate = newHeight - $(self).outerHeight();
                    }
                } else {
                    if (currentId > id) {
                        scrollUpdate = newHeight - $(self).outerHeight();
                    }
                }
            }

            $(self).stop(true, false).animate({ height: newHeight }, {
                duration: 200,
                easing: 'linear',
                complete: function () {
                    update();
                }
            });
        } else {
            update();
        }
    });

    return scrollUpdate;
}

export function resetChatItemExists() {
    let $chItems = $('.chatItem').not('.removing');
    let exists = $chItems.length > 0;
    $('.if-exists').toggle(exists);
    $('.if-notexists').toggle(!exists);

    $('.if-exists-op').toggleClass('op', !exists);
    $('.if-notexists-op').toggleClass('op', exists);

    let bothexists = $chItems.filter('.cc1').length > 0 && $chItems.filter('.cc2').length > 0;
    $('.if-bothexists').toggle(bothexists);
}

export function removeMiracleItemAnim(id, currentId, ismiracle) {
    var itemHeight = 0;
    var pxPerSecond = 100;
    $('.chatItem[data-id="' + id + '"]').each(function () {
        const self = this;

        itemHeight = $(self).outerHeight();
        var scrollDuration = 1000; //Math.round( (itemHeight / pxPerSecond) * 1000 );

        $(self).addClass('removing').stop(true, false).animate({ opacity: 0 }, {
            duration: 2000,
            easing: 'linear',
            complete: function () {
                //$( self ).remove();
                let currentScroll = $(window).scrollTop();
                let scrollUpdate = 0;
                let halfHeight = Math.round(itemHeight / 2);
                if (currentScroll > 0) {
                    scrollUpdate = 0 - (currentScroll - halfHeight > 0 ? halfHeight : currentScroll);
                }

                scrollUpdateAnim(scrollUpdate, scrollDuration);
                $(self).animate({
                    height: 0,
                    paddingTop: 0,
                    paddingBottom: 0,
                    marginTop: 0,
                    marginBottom: 0
                }, {
                    duration: scrollDuration,
                    easing: 'linear',
                    complete: function () {
                        $(self).remove();
                    }
                });
            }
        });
    });
}




